import { glideConfig } from "../library/glide";
import handleMediaQueryChange from "../utilities/helpers/_media_query";

const sportsContentTablet = () => {
    const sportsContentPlugins = document.querySelectorAll(
        "[data-sports-content-plugin] .glide",
    );

    if (sportsContentPlugins.length === 0) return;

    for (const plugin of sportsContentPlugins) {
        glideConfig(plugin, {
            type: "slider",
            focusAt: 0,
            startAt: 0,
            perView: 2,
            rewind: false,
            gap: 16,
            bound: true,
            // 2 items per swipe
            perSwipe: "|",
        });
    }

    // Add tablet class to control the display of certain bullet
    const bulletParent = document.querySelectorAll(".glide__bullets");
    bulletParent.forEach((item) => item.classList.add("tablet"));
};

const sportsContentMobile = () => {
    const sportsContentPlugins = document.querySelectorAll(
        "[data-sports-content-plugin] .glide",
    );

    if (sportsContentPlugins.length === 0) return;

    for (const plugin of sportsContentPlugins) {
        glideConfig(plugin, {
            type: "slider",
            focusAt: 0,
            startAt: 0,
            perView: 1,
            rewind: false,
            gap: 12,
            bound: true,
        });
    }
};

const sportsContentSlider = () => {
    handleMediaQueryChange(sportsContentMobile, sportsContentTablet);
};

const initializeSportsContent = () => {
    sportsContentSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeSportsContent);
} else {
    initializeSportsContent();
}

export { sportsContentSlider };
